export enum EUnitOfMeasure {
    Metric,
    Imperial,
}

export enum ETypeOfQuay {
    Vertical,
    Sloped,
    SlopedWithPiles,
}

export enum EPropellerDirectionWithRespectToTheQuay {
    Parallel,
    Transversal,
}

export enum ETypeOfPropeller {
    MainPropeller,
    BowThruster,
}

export enum EPropellerEquippedWithNozzles {
    No,
    Yes,
}

export enum EMaterialCategory {
    RenoMac = 1,
    CubiMac = 2,
    RipRap = 4,
    Other = 8,
}

export enum EMaterialType {
    NoType,
    ProtectionSystems,
    NaturalSoils,
    SoilBioengineeringNaturalVegetation,
}

export enum EActiveDoubleLayer {
    No,
    Yes,
}

export enum ENumberOfPropellers {
    Single = 1,
    Double = 2,
}

export enum EStatus {
    Public,
    Test,
    Deleted,
}

export enum EProducer {
    Maccaferri = 'Maccaferri',
    Other = 'Other',
}

export enum ERole {
    Standard,
    Admin,
    Observer,
}
